<script lang="ts">
  import maplibregl from 'maplibre-gl';
  import 'maplibre-gl/dist/maplibre-gl.css';

  let {
    latitude,
    longitude,
    label,
    onmoveend,
  }: {
    latitude: number;
    longitude: number;
    label: string;
    onmoveend?: (latitude: number, longitude: number) => void;
  } = $props();

  function map(container: HTMLElement) {
    const instance = new maplibregl.Map({
      container,
      style: 'https://tiles.openfreemap.org/styles/liberty',
      center: [longitude, latitude],
      zoom: 14,
      attributionControl: { compact: true },
    });
    // allow zooming via the +/- buttons, but don't hijack page scrolling
    instance.scrollZoom.disable();
    instance.addControl(
      new maplibregl.NavigationControl({ showCompass: false }),
    );
    const marker = new maplibregl.Marker()
      .setLngLat([longitude, latitude])
      .addTo(instance);
    // keep the marker pinned to the center while panning
    // and report the new center when the drag ends
    if (onmoveend) {
      instance.on('move', () => marker.setLngLat(instance.getCenter()));
      instance.on('moveend', () => {
        const center = instance.getCenter();
        onmoveend(center.lat, center.lng);
      });
    }
    // the compact attribution control starts expanded and covers the
    // small map, so collapse it after the map has loaded
    instance.once('load', () => {
      const attribution = container.querySelector(
        'details.maplibregl-ctrl-attrib',
      );
      attribution?.removeAttribute('open');
      attribution?.classList.remove('maplibregl-compact-show');
    });

    // keep the canvas in sync with the container's fluid width
    const resizeObserver = new ResizeObserver(() => instance.resize());
    resizeObserver.observe(container);

    return () => {
      resizeObserver.disconnect();
      instance.remove();
    };
  }
</script>

<div class="space-map" aria-label={label} {@attach map}></div>

<style>
  .space-map {
    width: 100%;
    height: 100%;
  }
</style>
